<template>
  <div>
    <contact-form
      topTitle="Subscribe"
      topSubtitle="Choose in this form if you would like to get notified when our next category rankings (Top Computer Degrees, Top Data Science and AI Degrees, Top Digital Training Formats, Top Online Professional Training and Executive Programs & Top Institutions with the most Innovative Learning Formats) are available"
      type="subscribeDL"
      hiddenName="type"
      hiddenValue="subscribe to digital leaders"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h3>Thank you for contacting us! <br /></h3>
            </div>
          </div>
        </div>
      </div>
    </contact-form>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm';
export default {
  data() {
    return {
      contactTitle: 'Feel free to contact us by filling <br /> the following form :'
    };
  },
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
</style>
